<template>
  <div>
    <div class="pileDetail">
      <div>
        <el-image :src="image" />
      </div>
      <div class="details">
        <div class="specifier">
          <h1>充电桩 360kw-480kw柔性充电堆</h1>
          <h3>产品特征 Product Features</h3>
          <ul>
            <li>采用全矩阵拓扑接口，功率按需分配，2~12枪进行灵活配置，满足客制化需求；支持运维平台远程诊断故障，支持远程OTA和USB系统升级，支持多平台接入</li>
          </ul>
        </div>
        <div class="application">
          <h3>应用领域 Application Area</h3>
          <span>适用于学校、小区、办公场所等噪音敏感区域</span>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c60"-->
<!--          label="360kw"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c480"-->
<!--          width="360px"-->
<!--          label="480kw">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Pile480kw",
  data(){
    return{
      image:require('../../../assets/images/production/pile/充电堆360kw 480kw.jpg'),
      tableData: [
        {
          type: '输入电压',
          c60: '323~437V',
          c480: '304~465V',
        },
        {
          type: '输入频率',
          c60: '45~65Hz',
          c480: '45~65Hz',
        },
        {
          type: '输入功率因数',
          c60: '≥0.99',
          c480: '≥0.99',
        },
        {
          type: '输出电压范围',
          c60: '200~750V/200~1000V',
          c480: '200~750V/200~1000V',
        },
        {
          type: '输出电流范围',
          c60: '0~1080A',
          c480: '0~1454A',
        },
        {
          type: '整机效率',
          c60: '峰值效率≥95%',
          c480: '峰值效率≥95%',
        },
        {
          type: '工作温度',
          c60: '-20~65℃',
          c480: '-20~65℃',
        },
        {
          type: '工作湿度',
          c60: '≤95%',
          c480: '≤95%'
        },
        {
          type: '海拔高度',
          c60: '≤2000m',
          c480: '≤2000m',
        },
        {
          type: '防护等级',
          c60: 'IP54',
          c480: 'IP54',
        },
        {
          type: '外观尺寸',
          c60: '400*700*1750',
          c480: '800*1400*1800',
        },
        {
          type: '保护功能',
          c60: '输入过欠压保护、输入过流保护、防浪涌保护、输出短路保护、过温保护、防反灌保护、电池主动保护、紧急停机等保护功能',
          c480: '输入过欠压保护、输入过流保护、防浪涌保护、输出短路保护、过温保护、防反灌保护、电池主动保护、紧急停机等保护功能',
        },
        {
          type: '通信接口',
          c60: 'CAN、RS485和以太网接口',
          c480: 'CAN、RS485和以太网接口',
        }
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      //console.log(row,column,rowIndex,columnIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  img{
    float: left;
    height: 523.8px;
    width: 379.8px;
    padding: 20px 20px;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 85%;
      ul{
        width: 80%;
        li{
          list-style: none;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>
